module.exports = __webpack_public_path__ + "img/step-5.5a1aef26.jpg";